/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { get2FactorAuthToken } from '../ngrx/state/two-factor-auth';
import { ApplicationState } from '../../reducers';
import { map } from 'rxjs/operators';
import { TokenValidatorService } from '../services/token-validator/token-validator.service';

@Injectable({
  providedIn: 'root',
})
export class TwoFactorAuthGuard {
  constructor(
    private readonly store: Store<ApplicationState>, private readonly tokenValidatorService: TokenValidatorService,
    private readonly router: Router,
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    return this.store.select(get2FactorAuthToken).pipe(map((token) => {
      if(token) {
        const isTokenValid = !this.tokenValidatorService.isTokenExpired(token);
        if(!isTokenValid) {
          this.router.navigate(['/login']);
        }
        return isTokenValid;
      }
      this.router.navigate(['/login']);
      return false;
    }));
  }
}
